/**
 * Cross-Sell Hotspot Indicators
 * Handles clicks on product image hotspots to open Quick Buy modal
 * Works for both desktop and mobile
 */

// Use capture phase to ensure this handler runs before gallery handlers
document.addEventListener(
  "click",
  (event) => {
    const indicator = event.target.closest(".cross-sell-indicator");
    if (!indicator) return;

    // Stop event immediately to prevent gallery from opening
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productHandle = indicator.dataset.productHandle;
    if (!productHandle) {
      console.warn("[Cross-Sell] No product handle found on indicator");
      return;
    }

    const productUrl = `/products/${productHandle}`;

    // Wait a bit to ensure other handlers have been prevented
    setTimeout(() => {
      // Try to find existing Quick Buy button first
      const quickBuyBtn = document.querySelector(
        `[data-quickbuy-url="${productUrl}"]`
      );

      if (quickBuyBtn) {
        // Use existing button
        quickBuyBtn.click();
      } else {
        // Create a temporary button to trigger Quick Buy
        // This ensures the quickbuy.js handler can find the element
        const tempBtn = document.createElement("button");
        tempBtn.setAttribute("data-quickbuy-url", productUrl);
        tempBtn.style.display = "none";
        tempBtn.style.visibility = "hidden";
        tempBtn.style.position = "absolute";
        tempBtn.style.top = "-9999px";
        tempBtn.setAttribute("aria-hidden", "true");
        document.body.appendChild(tempBtn);

        // Use a more reliable method to trigger the click
        // Dispatch a proper click event that will be caught by quickbuy.js
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
          detail: 1,
          buttons: 1,
        });

        // Also try direct click as fallback
        try {
          tempBtn.click();
        } catch (e) {
          tempBtn.dispatchEvent(clickEvent);
        }

        // Clean up after a short delay
        setTimeout(() => {
          if (document.body.contains(tempBtn)) {
            document.body.removeChild(tempBtn);
          }
        }, 200);
      }
    }, 10);
  },
  true
); // Use capture phase (true) to run before other handlers
